module.exports = __webpack_public_path__ + "media/bg-video.d1425dc5.mp4";